module.exports = __webpack_public_path__ + "static/media/cap-greece.f745472e.png";